export default __webpack_public_path__ + "static/media/Rectangle 116.45ac6e06.png";